module.exports = function() {
  return new Worker(__webpack_public_path__ + "8e01f490b677a8c6c8e8.worker.js");
};